<template>
    <ModelIndexLayout
        :modelNamePlural="__('admin::alerts.alerts')"
    >

        <Table
            :headings="[
                '#',
                __('admin::labels.element'),
                __('admin::labels.message'),
                __('admin::labels.created_at'),
            ]"
            :paginator="paginator"
            :with-filters="false"
            :with-actions="false"
        >

            <template #results>
                <tr v-for="alert in paginator.data" :key="alert.id">
                    <td>#{{ alert.id }}</td>
                    <td>
                        <span v-if="alert.alertable_type === 'App\\Models\\ProjectFeed' && alert.alertable?.project">
                            {{ __('admin::projects.project') }}:
                            <TableLink :href="$route('admin::projects.feeds.index', { project: alert.alertable.project_id })">{{ alert.alertable.project?.name }}</TableLink>
                            >
                            {{ __('admin::feeds.feed') }}:
                            <TableLink :href="$route('admin::projects.feeds.edit', { project: alert.alertable.project_id, feed: alert.alertable.id })">{{ alert.alertable.name }}</TableLink>
                        </span>
                        <span v-if="alert.alertable_type === 'App\\Models\\Property' && alert.alertable">
                            {{ __('admin::properties.property') }}:
                            <TableLink :href="$route('admin::projects.properties.edit', { project: alert.alertable.project_id, property: alert.alertable.id })">{{ alert.alertable.external_id }}</TableLink>
                        </span>
                    </td>
                    <td>{{ alert.message }}</td>
                    <td>{{ $datetime(alert.created_at) }}</td>
                </tr>
            </template>

        </Table>

    </ModelIndexLayout>
</template>

<script>
import ModelIndexLayout from '@/Layouts/ModelIndexLayout'
import Table from '@/Components/Table'
import TableLink from "@/Components/TableLink";

export default {
    components: {
        TableLink,
        ModelIndexLayout,
        Table,
    },
    props: {
        paginator: Object,
        request: Object,
    },
}
</script>
